import { Directive, HostListener, ElementRef, Input, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[cmSidebarShowHide]'
})
export class SidebarShowHideDirective implements AfterViewInit {
  @Input() cmSidebarShowHide: boolean;

  private openIcon = 'fa-angle-up';
  private closeIcon = 'fa-angle-down';

  private routerLinks = [];

  private isOpen = false;

  constructor(private elRef: ElementRef,
    private router: Router) {

    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const urlFirstSegment = this.getRouteFirstSegment(this.router.url);
      if (this.routerLinks.includes(urlFirstSegment) && !this.isOpen) {
        this.show();
      }
    });
  }

  @HostListener('click', ['$event']) onClick(event) {
    event.stopPropagation();
    this.isOpen ? this.hide() : this.show();
  }

  ngAfterViewInit(): void {
    this.getAllRouterLinksInSection();
    this.setInitialState();
  }

  show() {
    this.elRef.nativeElement.className += ' opened';

    const elementToHideShow = this.elRef.nativeElement.nextElementSibling;
    elementToHideShow.className = elementToHideShow.className.replace(' d-none', '');

    const iconElement = this.elRef.nativeElement.querySelector('i');
    iconElement.className = iconElement.className.replace(this.closeIcon, this.openIcon);

    this.isOpen = true;
  }

  hide() {
    this.elRef.nativeElement.className = this.elRef.nativeElement.className.replace(' opened', '');

    const elementToHideShow = this.elRef.nativeElement.nextElementSibling;
    elementToHideShow.className += ' d-none';

    const iconElement = this.elRef.nativeElement.querySelector('i');
    iconElement.className = iconElement.className.replace(this.openIcon, this.closeIcon);

    this.isOpen = false;
  }

  getAllRouterLinksInSection() {
    // last element sometimes does not have siblings
    if (this.elRef.nativeElement.nextElementSibling) {
      const linkElements = this.elRef.nativeElement.nextElementSibling.querySelectorAll('a');
      linkElements.forEach(item => {
        const link = item.getAttribute('routerlink');
        if (link !== null && link !== undefined && link !== '') {
          this.routerLinks.push(this.getRouteFirstSegment(link));
        }
      });
    }
  }

  setInitialState() {
    // if element does not have any routes, just hide it
    if (this.routerLinks.length === 0) {
      this.elRef.nativeElement.className += ' d-none';
      return;
    }
    const urlFirstSegment = this.getRouteFirstSegment(this.router.url);
    if (this.cmSidebarShowHide || this.routerLinks.includes(urlFirstSegment)) {
      this.elRef.nativeElement.innerHTML = this.elRef.nativeElement.innerHTML + '<i class="far ' + this.openIcon + '"></i>';
      this.elRef.nativeElement.className += ' opened';
      this.isOpen = true;
    } else {
      this.elRef.nativeElement.innerHTML = this.elRef.nativeElement.innerHTML + '<i class="far ' + this.closeIcon + '"></i>';
      this.elRef.nativeElement.nextElementSibling.className += ' d-none';
    }
  }

  getRouteFirstSegment(url: string) {
    if (url.indexOf('/') === -1) {
      return url;
    }

    const segments = url.split('/');
    for (let i = 0; i < segments.length; i++) {
      if (segments[i].length > 0) {
        return segments[i];
      }
    }
  }

}
